import React, { forwardRef, useImperativeHandle } from 'react';
import { shape, func } from 'prop-types';
import { Form } from 'semantic-ui-react';
import { Formik, Field } from 'formik';
import { InputField, TextAreaField } from 'Modules/Formik';
import useClinicDetail from 'Containers/Home/hooks/useClinicDetail';

import { MemoRandumSchema } from './validation';

const MemoRandumForm = forwardRef((props, ref) => {
  const { onSubmit, initialValues } = props;
  const { clinicId } = initialValues;
  const { clinicDetail } = useClinicDetail(clinicId);

  let mHandleSubmit = {};
  useImperativeHandle(
    ref,
    () => ({
      submit: mHandleSubmit,
    }),
    [mHandleSubmit],
  );

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={MemoRandumSchema}>
      {({ handleSubmit }) => {
        mHandleSubmit = handleSubmit;
        return (
          <Form>
            <Field label="Subject" name="subject" component={InputField} />
            <Field label="Patient name" name="patientName" component={InputField} />
            <Field label="NRIC / Passport number" name="patientNric" component={InputField} />
            <Field label="Content" name="content" component={TextAreaField} />
            <div>Clinic: {clinicDetail?.name}</div>
          </Form>
        );
      }}
    </Formik>
  );
});

MemoRandumForm.propTypes = {
  initialValues: shape({}),
  onSubmit: func.isRequired,
};

MemoRandumForm.defaultProps = {
  initialValues: {},
};

export default MemoRandumForm;
